<template>
   <div class="match-select">
    <h2 class="match-select-title">
      <span v-if="auction_select_type === 'auctions'">流拍撮合</span>
      <span v-if="auction_select_type === 'enquiries'">询价撮合</span>
    </h2>
    <div class="match-item-list">

      <div v-if="auction_select_type === 'auctions'">
          <!-- 流拍每条记录 -->
          <div @click="goLink('auctions',item.auction_id)" v-for="(item,index) in matchable_auctions"  :key="index" class="match-item-record">
            <div class="match-item-line">
              <label>出价有效期至</label>
              <span>{{item.finished_at}}</span>
            </div>
            <div class="match-item-line">
              <label>最高出价</label>
              <span>{{(item.maximum_price / 1000000).toFixed(2)}}万</span>
            </div>
            <div class="match-item-line">
              <label>报价人次</label>
              <span>
                {{item.bidders_count}}人/{{item.bids_count}}次
              </span>
            </div>
          </div>
          <!-- 流拍每条记录 -->
      </div>

      <!-- 询价撮合选择列表 -->
      <div v-if="auction_select_type === 'enquiries'">
        <!-- 询价每条记录 -->
        <div @click="goLink('enquiries',item.enquiry_id,item.enquiry_type)"  v-for="(item,index) in matchable_enquiries"  :key="index" class="match-item-record">
          <div class="match-item-line">
            <label>报价有效期至</label>
            <span>{{item.finished_at}}</span>
          </div>
          <div class="match-item-line">
            <label>最高报价</label>
            <span>{{(item.maximum_price / 1000000).toFixed(2)}}万</span>
          </div>
          <div class="match-item-line">
            <label>报价人次</label>
            <span>
              {{item.quote_count}}人
            </span>
          </div>
        </div>
        <!-- 询价每条记录 -->
      </div>
      <!-- 询价撮合选择列表 -->

    </div>
   </div>
</template>

<script>
export default {
  data() {
    return {
      auction_car_id: '',
      auction_select_type: '',
      matchable_auctions: [], // 流拍撮合选择
      matchable_enquiries: [] // 询价撮合选择
    }
  },
  created() {
    this.initializationData()
  },
  methods: {
    initializationData() {
      let id = this.$route.params.id
      let type = this.$route.params.type

      this.auction_car_id = id
      this.auction_select_type = type

      if (type === 'auctions') {
        // 流拍撮合数据
        this.getMatchableAuctions()
      } else if (type === 'enquiries') {
        // 询价撮合数据
        this.getMatchableEnquiries()
      }
    },
    /**
       * 流拍撮合选择
       */
    getMatchableAuctions() {
      let auctionCarId = this.auction_car_id
      this.$rest.match.getMatchableAuctionsList(null, auctionCarId + '/matchable_auctions').then((res) => {
        if (res.code === 0) {
          this.matchable_auctions = res.data.matchable_auctions
        } else {
          this.showToast(res.message)
        }
      })
    },
    /**
       * 询价撮合选择
       */
    getMatchableEnquiries() {
      let auctionCarId = this.auction_car_id
      this.$rest.match.getMatchableEnquiriesList(null, auctionCarId + '/matchable_enquiries').then((res) => {
        if (res.code === 0) {
          this.matchable_enquiries = res.data.matchable_enquiries
        } else {
          this.showToast(res.message)
        }
      })
    },
    /**
       * 跳转到相应的页面
       * 1、流拍撮合跳转到出价信息页面 id 列表中的 auction_id 字段
       * 2、询价撮合跳转到询价信息页面
       */
    goLink(type, id, enquiryType) {
      if (type === 'auctions') {
        // 1、流拍撮合跳转到出价信息页面
        this.$router.push({ path: `/auction/offer/${id}` })
      } else if (type === 'enquiries') {
        // 2、询价撮合跳转到询价信息页面
        // 区分是 enquiry_type,0为线索询价，1为车辆询价
        if (enquiryType === 0) {
          this.$router.push({ path: `/inquiry/inquiryInfo/${id}/inquiry`, query: { match: true } })
        } else if (enquiryType === 1) {
          this.$router.push({ path: `/inquiry/inquiryInfo/${id}/auction`, query: { match: true } })
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../stylesheets/modules/auction/matchSelect.less";
</style>
